(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Recogito", [], factory);
	else if(typeof exports === 'object')
		exports["Recogito"] = factory();
	else
		root["Recogito"] = factory();
})(self, function() {
return 